import { useState, useEffect } from 'react';

export const useSearchHistory = (type) => {
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const savedHistory = localStorage.getItem(`searchHistory_${type}`);
    if (savedHistory) {
      try {
        setHistory(JSON.parse(savedHistory));
      } catch (error) {
        console.error('Error parsing search history:', error);
      }
    }
  }, [type]);

  const addToHistory = (item) => {
    const newHistory = [
      { ...item, timestamp: new Date().toISOString() },
      ...history.filter(h => h.prompt !== item.prompt) // Remove duplicates
    ].slice(0, 10); // Keep only last 10 items

    setHistory(newHistory);
    localStorage.setItem(`searchHistory_${type}`, JSON.stringify(newHistory));
  };

  const removeFromHistory = (prompt) => {
    const newHistory = history.filter(item => item.prompt !== prompt);
    setHistory(newHistory);
    localStorage.setItem(`searchHistory_${type}`, JSON.stringify(newHistory));
  };

  const clearHistory = () => {
    setHistory([]);
    localStorage.removeItem(`searchHistory_${type}`);
  };

  return {
    history,
    addToHistory,
    removeFromHistory,
    clearHistory
  };
};